import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { ILinks } from './Tabs';
import { TabLink } from "./TabLink";

interface TabsHeaderProps {
  links: ILinks[];
}

export const TabsHeader: FC<TabsHeaderProps> = ({ links }) => {
  const pathName = useLocation().pathname;

  return (
    <div className="tabs">
      {
        links.map((elem, index) => (
          <TabLink key={elem.route + index} link={elem} active={pathName === elem.route} />
        ))
      }
    </div>
  );
};
